<div class="popin-content-header">
    <div class="bandeau-header">
        <div class="left-part" [style.flexBasis.%]="percentLeftPart">
            <ng-content select="[left-part]"></ng-content>
        </div>
        <div class="middle-part">
            <ng-content select="[middle-part]"></ng-content>
        </div>
        <div class="right-part" [style.flexBasis.%]="percentRightPart">
            <ng-content select="[right-part]"></ng-content>
        </div>
    </div>
</div>
